<template>
	<div class="flow-toggle-box" :selected="selected" @click="handleClick($event)">
		<slot />
	</div>
</template>
<script>
import { defineComponent } from "vue";

export default defineComponent({
	name: "ToggleBox",
	props: {
		selected: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClick(e) {
			/**
			 *
			 * Click event : triggered when icon is clicked
			 *
			 * @event click
			 */
			this.$emit("click", e);
		}
	}
});
</script>
<style lang="scss">
div.flow-toggle-box {
	height: 36px;
	min-width: 36px;
	border-radius: 4px;
	background-color: var(--gray-500);
	display: inline-flex;
	justify-content: center;
	align-items: center;
	padding: 10px;
	&[selected] {
		background-color: var(--primary-300);
	}
	flex: 0 0 auto;
	> * + * {
		margin-left: 10px;
	}
	cursor: pointer;
}
</style>
